import { render, staticRenderFns } from "./MasterCreatedGroupClassDetailsContent.vue?vue&type=template&id=4530af5e"
import script from "./MasterCreatedGroupClassDetailsContent.vue?vue&type=script&lang=js"
export * from "./MasterCreatedGroupClassDetailsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports